import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import { AxiosPromise } from 'axios'
import { RMA } from '@one/types'
import qs from 'qs'

export class BackofficeRmaApi extends ApiServiceWithSettings {
  complaintReasonList(): AxiosPromise<
    Array<RMA.Backoffice.Response.ComplaintReasonDto>
  > {
    return this.get('/complaint-reason', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE,
      cache: {
        ttl: 60 * 100,
        tags: ['rma-bo']
      }
    })
  }

  complaintReasonHandler(
    form: RMA.Backoffice.Request.ComplaintReasonFormDto
  ): AxiosPromise<void> {
    this.invalidate(['rma-bo'])
    return this.post('/complaint-reason', form, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  deleteComplaintReason(complaintReasonId: string): AxiosPromise<void> {
    this.invalidate(['rma-bo'])
    return this.delete(`/complaint-reason/${complaintReasonId}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  getComplaints(
    pageNumber: number,
    pageSize: number,
    clientId: string | null,
    statusId: number | null,
    createDateBefore: string | null,
    createDateAfter: string | null,
    demandId: number | null,
    source: string | null
  ): AxiosPromise<RMA.Backoffice.Response.PagerComplaintDto> {
    return this.get('/complaints', {
      params: {
        pageNumber,
        pageSize,
        clientId,
        statusId,
        createDateBefore,
        createDateAfter,
        demandId,
        source
      },
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE,
      paramsSerializer: function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    })
  }

  getComplaintStatuses(): AxiosPromise<
    RMA.Backoffice.Response.ComplaintStatusDto2[]
  > {
    return this.get('/complaint-statuses', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  createComplaintStatus(
    payload: RMA.Backoffice.Request.CreateComplaintStatusCommand
  ): AxiosPromise<RMA.Backoffice.Response.CreateComplaintStatusResult> {
    return this.post('/complaint-statuses', payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  updateComplaintStatus(
    payload: RMA.Backoffice.Response.ComplaintStatusDto2
  ): AxiosPromise<void> {
    return this.put('/complaint-statuses', payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  deleteComplaintStatus(
    payload: RMA.Backoffice.Request.RemoveComplaintStatusCommand
  ): AxiosPromise<void> {
    return this.delete('/complaint-statuses', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE,
      data: payload
    })
  }

  createComplaint(
    clientId: string,
    payload: RMA.Backoffice.Request.ComplaintFormDto
  ): AxiosPromise<RMA.Backoffice.Response.ComplaintCreationResult> {
    return this.post(`/complaint?clientId=${clientId}`, payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  editComplaint(
    payload: RMA.Backoffice.Request.ComplaintEditForm
  ): AxiosPromise<void> {
    return this.post('/complaint/edit', payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  editComplaintStatus(
    complaintId: string,
    statusId: number
  ): AxiosPromise<void> {
    return this.post(
      '/complaint/status',
      {},
      {
        authentication: Authentication.REQUIRED,
        aud: Audience.BACKOFFICE,
        params: { complaintId, statusId }
      }
    )
  }

  getComplaint(id: string): AxiosPromise<RMA.Backoffice.Response.ComplaintDto> {
    return this.get(`/complaint/${id}`, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  getDemands(): AxiosPromise<RMA.Backoffice.Response.DemandDto[]> {
    return this.get('/demands', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  editDemand(payload: RMA.Backoffice.Request.DemandDto2): AxiosPromise<void> {
    return this.put('/demands', payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  createDemand(
    payload: RMA.Backoffice.Request.CreateDemandCommand
  ): AxiosPromise<void> {
    return this.post('/demands', payload, {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  deleteDemand(
    payload: RMA.Backoffice.Request.RemoveDemandCommand
  ): AxiosPromise<void> {
    return this.delete('/demands', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE,
      data: payload
    })
  }

  getComplaintByNumber(
    number: string
  ): AxiosPromise<RMA.Backoffice.Response.ComplaintDto> {
    return this.get('/complaint-by-number', {
      params: { number },
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }
}
